import { createFileRoute } from "@tanstack/react-router";

import Notifications from "@/features/notifications";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/notifications/")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Notifications");

  return <Notifications />;
}
